import { defineMessages } from 'react-intl';

type MessageDescriptor = {
	id: string;
	description: string;
	defaultMessage: string;
};

export const messages: {
	crossIconLabel: MessageDescriptor;
} = defineMessages({
	crossIconLabel: {
		id: 'recommendation-card.cross-icon.label',
		defaultMessage: 'Dismiss recommendation',
		description:
			'Accessible label for the close icon button which dismisses the recommendation card',
	},
});
